<template>
  <div class="container">
    <header
      class="content"
      ref="contentEle"
      :style="contentBtnState === 1 ? 'overflow: hidden;height: 260px;' : ''"
    >
      <div class="content-top">
        <div class="user">
          <div class="avatar">
            <img alt="avatar" v-lazy="clockInData.user.avatar" />
          </div>
          {{ clockInData.user.name }}
        </div>
        <div
          class="content-btn"
          @click="handlerChangeContentState"
          v-if="contentBtnState"
        >
          {{ contentBtnState === 1 ? "展开" : "收起" }}
          <img
            src="@/assets/com_icon_dropdown_blue.png"
            alt="drop"
            class="drop-icon"
            :class="{ 'rotate-drop-icon': contentBtnState === 2 }"
          />
        </div>
      </div>

      <div
        class="text"
        v-if="clockInData.content"
        v-html="clockInData.content"
      ></div>
      <!-- 图片内容 -->
      <div
        class="img-list"
        :class="{ 'img-sty': clockInData.imgs.length > 1 }"
        v-if="clockInData.imgs.length > 0"
      >
        <lazy-component>
          <ClockInImg
            :url="item"
            :index="index"
            :length="clockInData.imgs.length"
            :noLongPress="true"
            @myClick="prevviewImg"
            v-for="(item, index) in clockInData.imgs"
            :key="index"
          />

          <div
            class="img-empty"
            v-if="
              clockInData.imgs.length === 2 || clockInData.imgs.length === 5
            "
          ></div>
        </lazy-component>
      </div>

      <!-- 音频内容 -->
      <div class="audio" v-if="clockInData.records.length > 0">
        <ClockInAudio
          v-for="(item, index) in clockInData.records"
          :audioSrc="item"
          :wxRecord="false"
          :key="index + 'record'"
        />
      </div>

      <!-- 视频内容 -->
      <div class="video-content" v-if="clockInData.video">
        <ClockInVideo :url="clockInData.video" />
      </div>
    </header>
    <div style="height: 16px; background: #fff;"></div>

    <div class="focus">
      <div class="title">点评</div>
      <div class="comment-input">
        <textarea
          name="text"
          id="text"
          placeholder="请输入点评内容，最多输入1000字"
          v-model="commentContent"
          maxlength="1000"
          class="text-area"
        ></textarea>
        <div class="text-count">{{ commentContent.length }}/1000</div>
      </div>
      <div class="title">评分</div>
      <div class="level">
        <img src="@/assets/level_s_gray.png" alt="level" @click="handlerSetLevel(1)" v-show="level !== 1" />
        <img src="@/assets/clock/grade-s.png" alt="level" v-show="level === 1" />
        <img src="@/assets/level_a_gray.png" alt="level" @click="handlerSetLevel(2)" v-show="level !== 2" />
        <img src="@/assets/clock/grade-a.png" alt="level" v-show="level === 2" />
        <img src="@/assets/level_b_gray.png" alt="level" @click="handlerSetLevel(3)" v-show="level !== 3" />
        <img src="@/assets/clock/grade-b.png" alt="level" v-show="level === 3" />
        <img src="@/assets/level_c_gray.png" alt="level" @click="handlerSetLevel(4)" v-show="level !== 4" />
        <img src="@/assets/clock/grade-c.png" alt="level" v-show="level === 4" />
      </div>
      <div class="set-top">
        <div class="tip-text">设为置顶打卡</div>
        <div class="switch">
          <van-switch
            v-model="isTop"
            size="30px"
            active-color="#FF9645"
            inactive-color="#E9E9EB"
          />
        </div>
      </div>
    </div>

    <div class="footer">
      <div class="submit-btn" @click="handlerComment">发送</div>
    </div>
  </div>
</template>

<script>
import { nextTick, ref, watch } from '@vue/composition-api';
import { resizeAlcdnUrl } from '@/common/js/utils';
import { ImagePreview, Switch, Toast } from 'vant';
import ClockInAudio from '@/components/clockInAudio/index.vue';
import ClockInImg from '@/components/clockInImg/index.vue';
import ClockInVideo from '@/components/ClockInVideo/index.vue';
import { setComment, setCardTop } from '@/api/clockin';
import router from '@/router';
import store from '@/store/index';

export default {
  components: {
    ClockInAudio,
    ClockInImg,
    ClockInVideo,
    [Switch.name]: Switch,
  },
  setup() {
    const clockInData = ref({});

    if (sessionStorage.adminComment) {
      const data = JSON.parse(sessionStorage.adminComment);
      data.user.avatar = resizeAlcdnUrl(data.user.avatar, 32);

      clockInData.value = data;
    }

    const contentEle = ref(null);
    const contentBtnState = ref(0);

    nextTick(() => {
      const height = contentEle.value.scrollHeight;

      if (height > 260) {
        contentBtnState.value = 1;
      }
    });

    const handlerChangeContentState = () => {
      if (contentBtnState.value === 1) {
        contentBtnState.value = 2;
      } else {
        contentBtnState.value = 1;
      }
    };

    /**
     * @description 预览图片
     */
    const prevviewImg = (index) => {
      ImagePreview(clockInData.value.imgs, index);
    };

    const commentContent = ref('');

    const level = ref(0);
    const handlerSetLevel = (value) => {
      level.value = value;
    };

    const handlerComment = () => {
      if (!commentContent.value.length) {
        Toast('请先输入点评内容～');
        return;
      }

      if (commentContent.value.length > 1000) {
        Toast('点评内容超出字数～');
        return;
      }

      const data = {
        content: commentContent.value,
        user_punch_id: clockInData.value.id
      };

      if (level.value) {
        data.level = level.value;
      }

      setComment(data).then((res) => {
        if (res.success) {
          store.commit('SET_ISUPDATE_CARD', {
            id: clockInData.value.id,
            isWho: 3,
            adminComment: {
              content: res.data,
              level: data.level
            }
          });

          router.go(-1);
        } else {
          Toast('点评失败');
        }
      });
    };

    const isTop = ref(false);
    isTop.value = clockInData.value.isTop;

    watch(isTop, (val) => {
      setCardTop(clockInData.value.id).then(() => {
        store.commit('SET_ISUPDATE_CARD', {
          id: clockInData.value.id,
          isWho: 3,
          adminComment: {
            isTop: isTop.value
          }
        });

        if (val) {
          Toast('置顶成功');
        } else {
          Toast('取消置顶');
        }
      }).catch(() => {
        Toast('操作失败');
      });
    });

    return {
      clockInData,
      contentEle,
      contentBtnState,
      commentContent,
      isTop,
      level,
      prevviewImg,
      handlerChangeContentState,
      handlerSetLevel,
      handlerComment
    };
  },
};
</script>

<style lang="stylus" scoped>
.content {
  padding: 16px;
  padding-top: 20px;
  padding-bottom 0
  background: #fff;
}

.content-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.user {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #191919;
}

.avatar {
  margin-right: 8px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #eee;

  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
}

.content-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 32px;
  border-radius: 18px;
  border: 1px solid #14B0FF;
  font-size: 14px;
  color: #14B0FF;

  .drop-icon {
    margin-left: 4px;
    width: 12px;
    height: 12px;
  }

  .rotate-drop-icon {
    transform: rotate(180deg);
  }
}

.text {
  margin-top: 16px;
  font-size: 15px;
  color: #191919;
  line-height: 22px;
}

.img-list {
  margin-top: 20px;
  width: 100%;
}

.img-sty>div {
  display: flex;
  flex-wrap: wrap;
  align-content: space-between;
  justify-content: space-between;
}

.img-empty {
  width: 109px;
  height: 109px;
}

.audio {
  margin-top: 20px;
  width: 210px;
}

.video-content {
  margin-top: 20px;
}

.focus {
  margin-top: 8px;
  margin-bottom 69px
  padding: 16px;
  padding-bottom: 12px;
  background: #fff;

  .title {
    font-size: 16px;
    color: #191919;
    font-weight: 500;
  }
}

.comment-input {
  position: relative;
  margin-top: 16px;
  margin-bottom: 32px;
  padding: 12px 12px 20px 12px;
  box-sizing: border-box;
  width: 100%;
  height: 150px;
  background: #F6F7FA;
  border-radius: 8px;

  .text-area {
    width: 100%;
    height: 114px;
    resize: none;
    border: none;
    outline: none;
    background: #F6F7FA;
    caret-color: #5580AE;
    font-size: 15px;
    line-height: 22px;
    color: #191919;

    &::-webkit-input-placeholder {
      color: #dadada;
    }
  }

  .text-count {
    position: absolute;
    bottom: 12px;
    right: 12px;
    font-size: 12px;
    color: #dadada;
  }
}

.level {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 16px;

  img {
    width: 68px;
    height: 68px;
  }
}

.set-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 28px;

  .tip-text {
    font-size: 16px;
    font-weight: 500;
    color: #191919;
  }
}

.footer {
  position: fixed;
  bottom: 0;
  width 100%
  max-width: 750px;
  height: 49px;
  padding: 5px 16px 4px 16px;
  background: #fff;

  .submit-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    background: linear-gradient(270deg, #FA8C1D 0%, #FCB13F 100%);
    border-radius: 6px;
    font-size 16px
    font-weight 500
    color #fff
  }
}
</style>
